import { removeCookie, setCookie } from '@utils/cookie';

export const userLogin = (token: string) => {
    setCookie('PDT', token);
    window.location.href = '/';
};

export const userLogout = () => {
    removeCookie('PDT');
    window.location.href = '/';
};
